var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 92,
    viewBox: "0 0 86 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0252 82.026L6.36719 0.971802H79.5296L72.865 82.0137L42.904 91.029L13.0252 82.026Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9453 36.9646H55.0653L55.9024 26.7849H42.9453V16.8439H65.9125L65.6927 19.5112L63.4411 46.9056H42.9453V36.9646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 62.7822L42.9596 62.7951L32.7593 59.8058L32.107 51.8773H22.9141L24.1968 67.4864L42.9582 73.1379L43 73.125V62.7822Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2875 46.4852L53.1842 59.7979L42.9688 62.7908V73.1336L61.7454 67.4857L61.8832 65.8059L63.4765 46.4852H54.2875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9746 16.8439V26.7849H20.8511L20.6676 24.551L20.2504 19.5112L20.0312 16.8439H42.9746ZM42.9435 36.966V46.907H32.8718L32.6883 44.6732L32.2705 39.6333L32.0519 36.966H42.9435Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg13);
export default __webpack_public_path__ + "static/media/13.dc463000b2959c11be9cc3414f357737.svg";
export { ForwardRef as ReactComponent };